<template>
  <div id="items" >
    <div class="items-content">

      <div class="grid-content percentH">
        <el-row :gutter="20">
          <el-col :span="4"> <el-button class="btn-halforg" size="small" @click="addItems">新增检查项目</el-button></el-col>
          <!--搜索-->
          <el-col :span="20" class="input_wrapper" style="padding-right: 10px">
            <el-select v-model="searchByLink" placeholder="请选择所属场景" size="small"  @change="searchItems">
              <el-option label="请选择所属场景" value=""></el-option>
              <el-option :label="item.linkTypeName" :value="item.linkTypeID" v-for="(item,index) in links" :key = "item.linkTypeID" ></el-option>
            </el-select>
            <el-input  class="producted" @change="searchItems"
                       placeholder="请输入检查项目名称"
                       suffix-icon="el-icon-search"
                       v-model="searchByName" size="small" >
            </el-input>
          </el-col>
        </el-row>
        <div>
          <el-table class="inbox"
            :data="checkItemList.list"
            stripe
            border
            :height="heightAll-110"
            style="width: 100%;margin: 10px 0px">
            <el-table-column align="center"
              prop="ordinal" width="50px"
              label="序号">
            </el-table-column>
            <el-table-column
              prop="itemName"
              label="项目名称">
            </el-table-column>
            <el-table-column width="100px"
              prop="linkName"
              label="执法场景">
            </el-table-column>

            <el-table-column label="操作"  width="300" align="center">
              <template slot-scope="scope">
                <!--@click="viewDetail(scope.$index, scope.row)"-->
                <!--转至子集的违法情形-->
                <el-button class="btn-halfpink"
                  size="mini" @click="toIllegal(scope.$index, scope.row)"
              >旗下项目</el-button>
                <!--@click="handleEdit(scope.$index, scope.row)"-->
                <el-button @click="updateItems(scope.$index, scope.row)"
                  size="mini"  class="btn-halforg"
            >编辑</el-button>
                <!--@click="handleDelete(scope.$index, scope.row)" v-show="isVisible"-->
                <el-button
                  size="mini"
                  class="btn-delete"  @click="deleteItems(scope.$index, scope.row)"
                 >删除</el-button>

              </template>
            </el-table-column>
          </el-table>

          <!--分页-->
          <el-row>
            <div class="fiexPos">
              <Pagination :handleSizeChange="handleSizeChange"
                          :handleCurrentChange="handleCurrentChange"
                          :currentPage="currentPage" :pagesize="pagesize" :total="checkItemList.total"
              > </Pagination>
            </div>
          </el-row>
        </div>

      </div>

      <!--添加检查项目||修改检查项目的弹框-->
      <el-dialog :title="checkItemsTitle" :visible.sync="checkItemsDialog" :append-to-body="true"  width="660px">
        <el-form :model="newitems" :rules="newitemsRules" ref="newitemsForm">
          <el-form-item label="项目序号" :label-width="formLabelWidth"  class="items" prop="sn">
            <el-input v-model.number="newitems.sn" autocomplete="off" size="small"  class="inpLen"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" :label-width="formLabelWidth"  class="items" prop="itemName">
            <el-input v-model="newitems.itemName" autocomplete="off" size="small"  class="inpLen"></el-input>
          </el-form-item>
          <el-form-item label="所属场景" :label-width="formLabelWidth" class="items" prop="linkId">
            <el-select v-model="newitems.linkId" size="small" style="width: 400px">
              <el-option :label="item.linkTypeName" :value="item.linkTypeID" v-for="(item,index) in links" :key = "item.linkTypeID" ></el-option>
            </el-select>
          </el-form-item>
        </el-form>


        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelItem('newitemsForm')">取 消</el-button>
          <el-button type="primary" @click="confirmItem('newitemsForm')">确 定</el-button>
        </div>
      </el-dialog>



    </div>
  </div>

</template>




<script>
  import Pagination from "../../components/core/Pagination"
  import {mapState} from 'vuex'
    export default {
        name: "Items",
      components:{
        Pagination
      },
      props:['heightAll'],
      data:function(){
          return {
            //分页的相关变量
            currentPage: 1, //当前页
            pagesize:10,  //每页的数据
            problemProInfo:30,
            //搜索关键词
            searchByLink:"", //根据场景搜索
            searchByName:"", //根据名称搜索

            //表格数据
            checkItemList:[],
            //场景列表
            links:[],
            //修改或添加的弹框
           checkItemsDialog: false,
            //修改或添加的form数据
            checkItemsTitle:"", //标题
            newitems:{
              sn:"", //序号
              itemName:"", //检查项目名称
              linkId:"" , //所属场景id
              itemId:"", //检查项目id
            },
            addFlag:false, //新增标志
            updFlag:false, //编辑标志


            formLabelWidth: '120px',

           //验证规则
            newitemsRules:{
              itemName: [
                { required:true, message: '请输入项目名称', trigger: 'blur' }
              ],
              sn: [
                { required:true, message: '请输入项目序号', trigger: 'blur' },
                { type: 'number', message: '序号必须为数字值'}
              ],
              linkId: [
                { required:true, message: '请选择所属场景', trigger: 'change' }
              ],
            }
          }
      },
      methods:{
        // 分页操作
        handleSizeChange(val) {
          this.pagesize = val;
          // this.reloadTab()
          this.getItemslist()
        },
        handleCurrentChange(currentPage) {
          this.currentPage = currentPage;
          // this.reloadTab()
          this.getItemslist()
        },

       // 获取检查项目列表
        getItemslist(){

          this.$http.post("common-data-server/common/item/item_list_page",{
            currentPage:this.currentPage,
            pageSize:this.pagesize,
            linkType:this.searchByLink?this.searchByLink:"",
            itemName:this.searchByName?this.searchByName:""
          },res=>{

         //console.log(res)
            this.checkItemList = res.obj;


          },res=>{
         //console.log(res)
          })
        },
        //获取场景列表
        getLinks(){
          this.$http.post("common-data-server/common/linkType/all_list",null,res=>{
         //console.log(res);
            this.links = res.obj;
          },res=>{
         //console.log(res);
          })
        },
        //搜索
        searchItems(){
          this.getItemslist()
        },

        //新增检查项目
        addItems(){
          this.checkItemsTitle ="新增检查项目";
          this.addFlag = true;
          this.updFlag = false;
          // 置空数据
          for(var key in this.newitems){
            this.newitems[key] = ""
          }
          this.checkItemsDialog = true;
          this.$nextTick(()=>{
            this.$refs['newitemsForm'].resetFields()
          })

        },
        //编辑检查项目
        updateItems(index,item){
          this.updFlag = true;
          this.addFlag = false;
          this.checkItemsDialog = true;
          this.checkItemsTitle="编辑项目"
          //回显数据
          this.newitems.itemName = item.itemName;
          this.newitems.sn = item.ordinal;
          this.newitems.linkId = item.linkId;
          this.newitems.itemId = item.itemID;
        },
        //取消新建||修改
        cancelItem(formName){
          this.$refs[formName].resetFields();
          this.checkItemsDialog = false;
        },
        //确认新建||修改
        confirmItem(formName){
          this.$refs[formName].validate((valid) => {
            if (valid) { //校验通过
              //若果是新增的话
              if(this.addFlag){
                this.$http.post("common-data-server/common/item/save_item",{
                  itemName:this.newitems.itemName,
                  linkId:this.newitems.linkId,
                  ordinal:this.newitems.sn
                },res=>{
                  this.$message({
                    message: '新建成功',
                    type: 'success'
                  });
                  //刷新页面
                  this.getItemslist();
                  this.checkItemsDialog = false
                },res=>{
                  this.$message({
                    message:res.msg,
                    type: 'error'
                  });
                  this.checkItemsDialog = true;
                })
              }
              //若果是编辑的话
              if(this.updFlag){
                this.$http.post("common-data-server/common/item/update_item",{
                  itemID:this.newitems.itemId,
                  itemName:this.newitems.itemName,
                  linkId:this.newitems.linkId,
                  ordinal:this.newitems.sn
                },res=>{
                  // console.log(res)
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  });
                  //刷新页面
                  this.getItemslist();
                  this.checkItemsDialog = false
                },res=>{
               //console.log(res)
                  this.$message({
                    message:res.msg,
                    type: 'error'
                  });
                  this.checkItemsDialog = true;
                })
              }

            } else {
              this.$message({
                message:"校验失败",
                type: 'error'
              });
              return false;
            }
          });
        },
         //删除检查项目
        deleteItems(index, item) {
          this.$confirm('确认删除名称是' + item.itemName + '的项目吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$http.post("common-data-server/common/item/del_item",{
              itemID:item.itemID
            },res=>{
              // console.log(res)
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getItemslist()
            },res=>{
           //console.log(res)
              // this.$message({
              //   type: 'error',
              //   message: res.msg
              // });
            })


          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          })
        },


        toIllegal(index,item){
       //console.log(item)
          // this.$router.push({name:"illegalStatus",params:{item:item}})
          this.$router.push({name:"illegalStatus",query:{item:item.itemID}})
        }
      },

      mounted() {
        this.getItemslist();
        this.getLinks();
      }
    }
</script>

<style scoped>
  @import "../../assets/dialog.css";
  @import "../../assets/reset.css";
  #items{
    background:white;
    overflow: hidden;

  }

  #items >.items-content{
    padding: 10px;
  }
  .grid-content{
    position: relative;
  }
  .grid-content .input_wrapper{
    text-align: right;
    /*float: right;*/
  }
  .producted{
    width:25%;
  }
  /*弹框输入框宽度*/
  .inpLen {
    max-width: 400px;
  }
  .percentH{
    height: 100%;
  }
  /*分页*/
  .fiexPos{
    position: absolute;
    bottom: -30px;
  }


  /*自定義滾動條*/
  .inbox >>> .el-table__body-wrapper::-webkit-scrollbar {/*滚动条整体样式*/
    width: 7px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 7px;
  }
  .inbox >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(144,147,153,.5);
  }
  .inbox >>> .el-table__body-wrapper::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 0;
    background: rgba(0,0,0,0.1);
  }
</style>
